import { createContext, useContext, useState } from 'react';

type CurrentPage = {
  title: string;
  subtitle: string;
};

type CurrentPageContextProps = {
  currentPage: CurrentPage;
  setCurrentPage: (title: string, subtitle: string) => void;
};

export const CurrentPageContext = createContext<CurrentPageContextProps>({
  currentPage: { title: '', subtitle: '' }, // Provide default values
  setCurrentPage: () => {}, // Dummy function to satisfy TypeScript until it's provided by the provider
});

export const useCurrentPageContext = () => {
  const context = useContext(CurrentPageContext);
  if (!context) {
    throw new Error(
      'useCurrentPageContext must be used inside CurrentPageProvider'
    );
  }
  return context;
};

type CurrentPageProviderProps = {
  children: React.ReactNode;
};

export const CurrentPageProvider = ({ children }: CurrentPageProviderProps) => {
  const [currentPage, setCurrentPage] = useState<CurrentPage>({
    title: '',
    subtitle: '',
  });

  const handleSetCurrentPage = (title: string, subtitle: string) => {
    setCurrentPage({ title, subtitle });
  };

  return (
    <CurrentPageContext.Provider
      value={{ currentPage, setCurrentPage: handleSetCurrentPage }}
    >
      {children}
    </CurrentPageContext.Provider>
  );
};
